import { Hubs, HubSection as ThryveHubSection, HubSectionType } from 'utils/gloo-types';
import classNames from 'classnames';
import HubResourceSection from 'pages/_AdminAuthoringPages/_components/HubPreview/HubSectionPreview/HubResourceSection';
import { HubPreviewView } from 'pages/_AdminAuthoringPages/_components/HubPreview';
import HubImageSection from 'pages/_AdminAuthoringPages/_components/HubPreview/HubSectionPreview/HubImageSection';
import HubSplitSection from 'pages/_AdminAuthoringPages/_components/HubPreview/HubSectionPreview/HubSplitSection';
import HubTextSection from 'pages/_AdminAuthoringPages/_components/HubPreview/HubSectionPreview/HubTextSection';

export type HubSectionProps = {
  hub: Hubs;
  hubSection: ThryveHubSection;
  isFinalSection: boolean;
  previewView?: HubPreviewView;
};

const HubSectionPreview = ({ hub, hubSection, isFinalSection, previewView }: HubSectionProps) => {
  let sectionComponent: JSX.Element;
  switch (hubSection.type) {
    case HubSectionType.RESOURCE:
      sectionComponent = <HubResourceSection hubResourceSection={hubSection} previewView={previewView} />;
      break;
    case HubSectionType.IMAGE:
      sectionComponent = <HubImageSection hub={hub} hubImageSection={hubSection} previewView={previewView} />;
      break;
    case HubSectionType.TEXT:
      sectionComponent = <HubTextSection hubTextSection={hubSection} previewView={previewView} />;
      break;
    case HubSectionType.SPLIT:
      sectionComponent = <HubSplitSection hub={hub} hubSplitSection={hubSection} previewView={previewView} />;
      break;
  }
  return (
    <div
      className={classNames('px-[48px] py-[24px]', {
        'xl:px-[74px] xl:py-[56px]': !previewView,
        'px-[74px] py-[56px]': previewView === HubPreviewView.Desktop,
        'h-full': isFinalSection,
      })}
      style={{
        backgroundColor: hubSection.backgroundColor ?? '#fff',
      }}
    >
      {sectionComponent}
    </div>
  );
};

export default HubSectionPreview;
